import apiClient from './client';

export const fetchCatalog = async ({ filter } = {}) => {
  const params = {};
  if (filter && filter !== 'all') {
    params.filter = filter;
  }

  return apiClient.get('/catalog', {
    params,
  });
};

export const searchCatalog = async ({ query } = {}) => apiClient.get('/catalog/search', {
  params: {
    q: query || '',
  },
});

export default {
  fetchCatalog,
  searchCatalog,
};
